export enum Databases {
  DERBY = "Derby",
  POSTGRESQL = "PostgreSQL",
  H2 = "H2",
  HSQLDB = "HSQLDB",
  INFORMIX = "Informix",
  IBM_DB2 = "IBM DB2",
  ACCESS = "Microsoft Access",
  MSSQL = "Microsoft SQL Server",
  MYSQL = "MySQL",
  ORACLE = "Oracle",
  SQLITE = 'SQLite',
  TERADATA = "Teradata"
}

export const DatabaseInfo: { [key in Databases]: string } = {
  [Databases.POSTGRESQL]: "Supported PostgreSQL 8.2 and above",
  [Databases.ORACLE]: "Supported Oracle 19c, 21c, 23c",
  [Databases.MYSQL]: "Supported MySQL 5.6 and above",
  [Databases.MSSQL]: "Supported MSSQL 2008 and above",
  [Databases.IBM_DB2]: "Supported IBM DB2 11.1 and above",
  [Databases.SQLITE]: "Supported SQLite 3.x",
  [Databases.ACCESS]: "Supported Microsoft Access 2000-2016",
  [Databases.H2]: "Supported H2 1.4 and above",
  [Databases.HSQLDB]: "Supported HSQLDB 2.0 and above",
  [Databases.DERBY]: "Supported Derby 10.15.1.3 and above",
  [Databases.INFORMIX]: "Supported Informix 11 and above",
  [Databases.TERADATA]: "Supported Teradata 16.20 and above"
};
